import { useMutation } from '@tanstack/react-query';
import Axios, { AxiosError } from 'axios';

const simulateXenditPayment = async (externalId: string, amount: number) => {
  const token = process.env?.REACT_APP_XENDIT_TOKEN || '';
  try {
    const res = await Axios.post(
      `https://api.xendit.co/callback_virtual_accounts/external_id=${externalId}/simulate_payment`,
      {
        amount,
      },
      {
        headers: {
          Authorization: `Basic ${token}`,
        },
      },
    );

    return res?.data;
  } catch (error) {
    if (error instanceof AxiosError)
      throw new Error(error?.response?.data?.message || error?.message);
    throw new Error('Something went wrong');
  }
};

type APIInput = {
  invoiceId: string;
  amount: number;
  externalId: string;
};

type APIResponse = Record<string, string>;

const useSimulatePaymentMutation = ({
  onMutate,
  onSettled,
}: {
  onMutate?: ((variables: APIInput) => void | Promise<void>) | undefined;
  onSettled?: (
    data: APIResponse | undefined,
    error: Error | null,
    variables: APIInput,
  ) => void;
}) => {
  return useMutation({
    mutationFn: ({ amount, externalId }: APIInput) =>
      simulateXenditPayment(externalId, amount),
    onMutate,
    onSettled,
  });
};

export default useSimulatePaymentMutation;
